const conditions = () => {
  return [{ assetClass: { $ne: '' } }, { assetClass: 'object.asset-class.options.kapitalgeber' }, { typeOfFinancing: 'object.type-of-financing.options.whole-loan' }]
}

export default conditions
